module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog\"> <div class=\"modal-content\"> <section class=\"modal-header\"> <h4 class=\"modal-title\">Delete Carrier Account</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> </section> <section class=\"modal-body\"> <p>Are you sure you want to delete your ")
    ; __append(escapeFn( locals.readable ))
    ; __append(" account with ID <code>")
    ; __append(escapeFn( locals.id ))
    ; __append("</code>?</p> </section> <section class=\"modal-footer\"> <button class=\"btn btn-clear cancel\" type=\"button\">Cancel</button> <button class=\"btn btn-danger confirm_delete\" type=\"button\">Delete</button> </section> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/delete_carrier_account_modal.ejs
// module id = 1319
// module chunks = 1